<template>
<div class="filter-body" >
    <div class="form-group">
        <label for=""> Product Shot</label>
        <select name="packshot_shot" class="form-control">
            <option v-for="(filter,index) in commonFilters" :selected="index === 0" :value="filter.key">{{filter.name}}</option>
        </select>
    </div>
    <div class="form-group">
        <label for=""> Flat Shot</label>
        <select name="flatshot_shot" class="form-control">
            <option v-for="(filter,index) in commonFilters" :selected="index === 0" :value="filter.key">{{filter.name}}</option>
        </select>
    </div>
    <div class="form-group">
        <label for=""> Model Shot</label>
        <select name="modelshot_shot" class="form-control">
            <option v-for="(filter,index) in commonFilters" :selected="index === 0" :value="filter.key">{{filter.name}}</option>
        </select>
    </div>
</div>
</template>

<script>
export default {
  data: function () {
    return {
      commonFilters: [
        { 'name': 'All', 'key': '' },
        { 'name': 'Complete', 'key': 'complete' },
        { 'name': 'Incomplete', 'key': 'incomplete' },
        { 'name': 'Skipped', 'key': 'skipped' }
      ],
      copyWrittenFilters: [
        { 'name': 'Complete', 'key': 'yes' },
        { 'name': 'Incomplete', 'key': 'no' }
      ]
    }
  },
  mounted: function () {
    $('.select2').select2()
  }
}
</script>

<style scoped>
    .select2.select2-container--default .select2-selection--multiple{
        background-color: #fff;
        border-color: 2px solid #dde2ec;
    }
</style>
